import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Cadastro from './components/CadastroExterno';
import DashboardCRM from './components/CRM/Dashboard';
import DashboardFormalizacao from './components/Formalizacao/Dashboard/Dashboard';
import ForceLogout from './components/ForceLogout/ForceLogout';
import DashboardRelacionamentos from './components/Relacionamentos/DashboardRelacionamentos';
import PlataformasAutenticacao from './services/authentication/PlataformasAutenticacao';
import ProtectedRoute from './services/authentication/ProtectedRoute';
import NotFound from './components/NotFound/NotFound';
import Home from './components/Home/Home';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import Configuracoes from './components/OneShell/Configuracoes/Configuracoes';
import {
  carregarEscopoAmbienteTenant,
  getEscopoComponentes,
  isAuthenticated
} from './services/authentication/auth';
import LoaderMain from './components/Shared/LoaderMain';
import Error from './components/NotFound/Error';
import Login from './components/Login/Login';
import { MenuSidebarProvider } from './contexts/MenuSidebarContext';
import Iframe from './components/OneShell/Iframe/Iframe';
import Favoritos from './components/OneShell/Favoritos/Favoritos';
import CapitalFlow from './pages/CapitalFlow/Cessao/CapitalFlow';
import GestaoCessao from './pages/CapitalFlow/GestaoCessao/GestaoCessao';
import DeferimentoLote from './components/Financeiro/DeferimentoLote';
import RemessasCriadas from './pages/Remessas/RemessasCriadas/RemessasCriadas';
import ConciliacaoFlow from './pages/CapitalFlow/ConciliacaoFlow/ConciliacaoFlowModeloTorre';

const RotaSistema = ({ children, props }) => {
  const [configAmbiente, setConfigAmbiente] = useState(false);

  useEffect(() => {
    carregarEscopoAmbienteTenant(configs => {
      if (configs) setConfigAmbiente(configs);
    });
  }, []);

  useEffect(() => {
    if (configAmbiente !== false) {
      if (document && document.title && configAmbiente.sistema && configAmbiente.sistema.tenant_name)
        document.title = `${configAmbiente.sistema.tenant_name.toLocaleUpperCase()} | Plataforma Digital`;

      const favicon = document ? document.getElementById('favicon') : false;
      const faviconUrl =
        configAmbiente && configAmbiente.imagens && configAmbiente.imagens.FAVICON
          ? configAmbiente.imagens.FAVICON
          : '';
      if (favicon) favicon.href = faviconUrl;
    }
  }, [configAmbiente]);

  return (
    <>
      {configAmbiente !== false && Object.keys(configAmbiente).length > 0 ? (
        <>{children}</>
      ) : configAmbiente === false ? (
        <div className="wrapper">
          <LoaderMain />
        </div>
      ) : (
        <div className="wrapper">
          <Error />
          {children}
        </div>
      )}
    </>
  );
};

const Rotas = () => {
  const [escopoAcesso, setEscopoAcesso] = useState(isAuthenticated() ? getEscopoComponentes() : false);
  const location = useLocation();

  return (
    <MenuSidebarProvider>
      <Routes>
        <Route
          path="/plataformas-autenticacao/:url/:tokenRefresh/:token"
          element={
            <RotaSistema>
              <PlataformasAutenticacao setEscopoAcesso={setEscopoAcesso} />
            </RotaSistema>
          }
        />

        <Route
          path="/cadastro"
          element={
            <RotaSistema>
              <Cadastro />
            </RotaSistema>
          }
        />

        <Route
          path="/login"
          element={
            <RotaSistema>
              <Login setEscopoAcesso={setEscopoAcesso} />
            </RotaSistema>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <RotaSistema>
              <ForgotPassword />
            </RotaSistema>
          }
        />

        <Route
          path="/reset-password/:token"
          element={
            <RotaSistema>
              <ResetPassword />
            </RotaSistema>
          }
        />

        <Route
          path="/home"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <Home setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/iframe/:idDepartamento64/:idSubMenu64"
          element={
            <RotaSistema key={location.key}>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <Iframe setEscopoAcesso={setEscopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/configuracoes"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <Configuracoes setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/favoritos"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <Favoritos setEscopoAcesso={setEscopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/plataforma_crm/dashboard"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" escopoAcesso={escopoAcesso}>
                <DashboardCRM escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/financeiro/indeferimento-lote"
          element={
            <RotaSistema>
              <ProtectedRoute ignorarEscopo={true}>
                <DeferimentoLote escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/plataforma_formalizacao/dashboard"
          element={
            <RotaSistema>
              <ProtectedRoute
                modulo="plataforma_formalizacao"
                contexto="dashboard"
                escopoAcesso={escopoAcesso}
              >
                <DashboardFormalizacao escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/plataforma_relacionamento/dashboard"
          element={
            <RotaSistema>
              <ProtectedRoute
                modulo="plataforma_relacionamento"
                contexto="dashboard"
                escopoAcesso={escopoAcesso}
              >
                <DashboardRelacionamentos escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route path="/force-logout" element={<ForceLogout />} />

        <Route path="/not-found" element={<NotFound escopoAcesso={escopoAcesso} />} />

        <Route
          path="*"
          element={
            <ProtectedRoute ignorarEscopo={true}>
              <Navigate to="home" replace />
            </ProtectedRoute>
          }
        />

        <Route
          path="/capital-flow/nova-cessao"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <CapitalFlow setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/plataforma_capital_flow/gestao-cessao-titulos"
          element={
            <RotaSistema>
              <ProtectedRoute
                modulo="plataforma_capital_flow"
                contexto="gestao-cessao-titulos"
                escopoAcesso={escopoAcesso}
              >
                <GestaoCessao setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/plataforma_capital_flow/conciliacao"
          element={
            <RotaSistema>
              <ProtectedRoute
                modulo="plataforma_capital_flow"
                contexto="conciliacao"
                ignorarEscopo={true}
                escopoAcesso={escopoAcesso}
              >
                <ConciliacaoFlow setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />

        <Route
          path="/remessas/criadas"
          element={
            <RotaSistema>
              <ProtectedRoute modulo="plataforma_crm" contexto="dashboard" ignorarEscopo={true}>
                <RemessasCriadas setEscopoAcesso={setEscopoAcesso} escopoAcesso={escopoAcesso} />
              </ProtectedRoute>
            </RotaSistema>
          }
        />
      </Routes>
    </MenuSidebarProvider>
  );
};

export default Rotas;
